(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[387],{

/***/ 9305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.product__also-viewed {\n  margin-top: var(--section-margin-sm);\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.product__installments-wrapper:not(:first-of-type) {\n  padding-top: .35rem;\n}\n.product__installments-text {\n  height     : 1.275rem;\n  display    : inline-block;\n  font-size  : var(--text-xxs);\n  line-height: var(--line-xxs);\n}\n.product__installments-text strong {\n  margin: 0 .25rem;\n}\n.product__installments-image {\n  height       : .75rem;\n  margin-bottom: -.05rem;\n}\n@media (min-width: 768px) {\n.product__installments {\n    padding: .15rem 0 0;\n}\n.product__installments-wrapper:not(:first-of-type) {\n    padding-top: 0;\n    margin-top : -1rem;\n}\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.product__recommended {\n  margin-top: var(--section-margin-sm);\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9198:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var scripts_vue_main__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3200);
/* harmony import */ var scripts_utils_smoothscroll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4836);
/* harmony import */ var scripts_utils_smoothscroll__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(scripts_utils_smoothscroll__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9346);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 * @file vendors@template.product.js
 * @file template.product.js
 *
 */








window.PSTheme.Vue.Product = new (vue__WEBPACK_IMPORTED_MODULE_2___default())({
  name: 'ProductWrapper',
  components: {
    'product': (__webpack_require__(6903)/* ["default"] */ .Z)
  }
}).$mount('.product');

/***/ }),

/***/ 9508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RS": function() { return /* binding */ mq_breakpoints; },
/* harmony export */   "ku": function() { return /* binding */ px_breakpoints; }
/* harmony export */ });
/* unused harmony export px_queries */
// EMs
let mq_breakpoints = {
  '--mobile-down': '(max-width: 25.99em)',
  '--mobile-up': '(min-width: 26em)',
  '--phablet-down': '(min-width: 32.49em)',
  '--phablet-up': '(min-width: 32.5em)',
  '--tablet-down': '(max-width: 39.99em)',
  '--tablet-up': '(min-width: 40em)',
  '--tablet-lg-down': '(min-width: 63.99em)',
  '--tablet-lg-up': '(min-width: 64em)',
  '--laptop-down': '(max-width: 71.99em)',
  '--laptop-up': '(min-width: 72em)',
  '--desktop-down': '(max-width: 99.99em)',
  '--desktop-up': '(min-width: 100em)',
  '--ultrawide': '(min-width: 125em)'
}; // Pixels

let px_breakpoints = {
  '--mobile-up': 416,
  '--phablet-up': 520,
  '--tablet-up': 640,
  '--tablet-lg-up': 1024,
  '--laptop-up': 1152,
  '--desktop-up': 1600,
  '--ultrawide': 2000
};
let px_queries = {
  '--mobile-up': '(min-width: 416px)',
  '--phablet-up': '(min-width: 520px)',
  '--tablet-up': '(min-width: 640px)',
  '--tablet-lg-up': '(min-width: 1024px)',
  '--laptop-up': '(min-width: 1152px)',
  '--desktop-up': '(min-width: 1600px)',
  '--ultrawide': '(min-width: 2000px)'
};


/***/ }),

/***/ 7342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y0": function() { return /* binding */ getState; },
/* harmony export */   "jX": function() { return /* binding */ addItem; },
/* harmony export */   "$G": function() { return /* binding */ updateItem; },
/* harmony export */   "XO": function() { return /* binding */ updateItemQuantityById; },
/* harmony export */   "Qk": function() { return /* binding */ updateNote; }
/* harmony export */ });
/* unused harmony exports getItemIndex, getItem, addItemFromForm, removeItem, clearItems, getAttributes, updateAttributes, clearAttributes, getNote, clearNote, getShippingRates */
/**
 * Cart API helper methods
 * ------------------------------------------------------------------------------
 * Reusable code for cart API methods
 *
 */

/**
 * Returns the state object of the cart
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function getState() {
  return cart();
}
/**
 * Returns the index of the cart line item
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the index number of the line item
 */

function getItemIndex(key) {
  validate_key(key);
  return cart().then(function (state) {
    var index = -1;
    state.items.forEach(function (item, i) {
      index = item.key === key ? i + 1 : index;
    });

    if (index === -1) {
      return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
    }

    return index;
  });
}
/**
 * Fetches the line item object
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */

function getItem(key) {
  validate_key(key);
  return cart().then(function (state) {
    var lineItem = null;
    state.items.forEach(function (item) {
      lineItem = item.key === key ? item : lineItem;
    });

    if (lineItem === null) {
      return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
    }

    return lineItem;
  });
}
/**
 * Add a new line item to the cart
 * @param {number} id The variant's unique ID
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */

function addItem(id, options) {
  options = options || {};
  validate_id(id);
  return cartAdd(id, options.quantity, options.properties);
}
/**
 * Add a new line item to the cart from a product form
 * @param {object} form DOM element which is equal to the <form> node
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */

function addItemFromForm(form) {
  validate_form(form);
  var formData = new FormData(form);
  validate_id(parseInt(formData.get('id'), 10));
  return cartAddFromForm(formData);
}
/**
 * Changes the quantity and/or properties of an existing line item.
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */

function updateItem(key, options) {
  validate_key(key);
  validate_options(options);
  return getItemIndex(key).then(function (line) {
    return cartChange(line, options);
  });
}
/**
 * 
 * Changes the quantity of an existing line item through it's variant id, useful when the key is not accessable.
 * @param {integer} variant.id
 * @param {number} quantity Setting to 0 will remove the item
 */

function updateItemQuantityById(id, qty) {
  return cartUpdateQuantityById(id, qty);
}
/**
 * Removes a line item from the cart
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */

function removeItem(key) {
  validate_key(key);
  return getItemIndex(key).then(function (line) {
    return cartChange(line, {
      quantity: 0
    });
  });
}
/**
 * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */

function clearItems() {
  return cartClear();
}
/**
 * Gets all cart attributes
 * @returns {Promise} Resolves with the cart attributes object
 */

function getAttributes() {
  return cart().then(function (state) {
    return state.attributes;
  });
}
/**
 * Sets all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */

function updateAttributes(attributes) {
  return cartUpdate({
    attributes: attributes
  });
}
/**
 * Clears all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */

function clearAttributes() {
  return getAttributes().then(function (attributes) {
    for (var key in attributes) {
      attributes[key] = '';
    }

    return updateAttributes(attributes);
  });
}
/**
 * Gets cart note
 * @returns {Promise} Resolves with the cart note string
 */

function getNote() {
  return cart().then(function (state) {
    return state.note;
  });
}
/**
 * Sets cart note
 * @returns {Promise} Resolves with the cart state object
 */

function updateNote(note) {
  return cartUpdate({
    note: note
  });
}
/**
 * Clears cart note
 * @returns {Promise} Resolves with the cart state object
 */

function clearNote() {
  return cartUpdate({
    note: ''
  });
}
/**
 * Get estimated shipping rates.
 * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
 */

function getShippingRates() {
  return cartShippingRates();
}
/**
 * Request helper functions
 */

function getDefaultRequestConfig() {
  return JSON.parse(JSON.stringify({
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;'
    }
  }));
}

function fetchJSON(url, config) {
  return fetch(url, config).then(function (response) {
    if (!response.ok) {
      throw response;
    }

    return response.json();
  });
}

function cart() {
  return fetchJSON('/cart.js', getDefaultRequestConfig());
}

function cartAdd(id, quantity, properties) {
  var config = getDefaultRequestConfig();
  config.method = 'POST';
  config.body = JSON.stringify({
    id: id,
    quantity: quantity,
    properties: properties
  });
  return fetchJSON('/cart/add.js', config);
}

function cartAddFromForm(formData) {
  var config = getDefaultRequestConfig();
  delete config.headers['Content-Type'];
  config.method = 'POST';
  config.body = formData;
  return fetchJSON('/cart/add.js', config);
}

function cartChange(line, options) {
  var config = getDefaultRequestConfig();
  options = options || {};
  config.method = 'POST';
  config.body = JSON.stringify({
    line: line,
    quantity: options.quantity,
    properties: options.properties
  });
  return fetchJSON('/cart/change.js', config);
}

function cartUpdateQuantityById(id, qty) {
  var config = getDefaultRequestConfig();
  delete config.headers['Content-Type'];
  config.method = 'POST';
  config.body = new URLSearchParams(`quantity=${qty}&id=${id}`);
  return fetchJSON('/cart/change.js', config);
}

function cartClear() {
  var config = getDefaultRequestConfig();
  config.method = 'POST';
  return fetchJSON('/cart/clear.js', config);
}

function cartUpdate(body) {
  var config = getDefaultRequestConfig();
  config.method = 'POST';
  config.body = JSON.stringify(body);
  return fetchJSON('/cart/update.js', config);
}

function cartShippingRates() {
  return fetchJSON('/cart/shipping_rates.json', getDefaultRequestConfig());
}
/**
 * Validation helper functions
 */


function validate_key(key) {
  if (typeof key !== 'string' || key.split(':').length !== 2) {
    throw new TypeError('Theme Cart: Provided key value is not a string with the format xxx:xxx');
  }
}

function validate_quantity(quantity) {
  if (typeof quantity !== 'number' || isNaN(quantity)) {
    throw new TypeError('Theme Cart: An object which specifies a quantity or properties value is required');
  }
}

function validate_id(id) {
  if (typeof id !== 'number' || isNaN(id)) {
    throw new TypeError('Theme Cart: Variant ID must be a number');
  }
}

function validate_properties(properties) {
  if (typeof properties !== 'object') {
    throw new TypeError('Theme Cart: Properties must be an object');
  }
}

function validate_form(form) {
  if (!(form instanceof HTMLFormElement)) {
    throw new TypeError('Theme Cart: Form must be an instance of HTMLFormElement');
  }
}

function validate_options(options) {
  if (typeof options !== 'object') {
    throw new TypeError('Theme Cart: Options must be an object');
  }

  if (typeof options.quantity === 'undefined' && typeof options.properties === 'undefined') {
    throw new Error('Theme Cart: You muse define a value for quantity or properties');
  }

  if (typeof options.quantity !== 'undefined') {
    validate_quantity(options.quantity);
  }

  if (typeof options.properties !== 'undefined') {
    validate_properties(options.properties);
  }
}

/***/ }),

/***/ 4836:
/***/ (function() {

// Element to move, time in ms to animate
window.scrollTo = function (element, duration) {
  var e = document.documentElement;

  if (e.scrollTop === 0) {
    var t = e.scrollTop;
    ++e.scrollTop;
    e = t + 1 === e.scrollTop-- ? e : document.body;
  }

  scrollToC(e, e.scrollTop, element, duration);
}; // Element to move, element or px from, element or px to, time in ms to animate


function scrollToC(element, from, to, duration) {
  if (duration <= 0) return;
  if (typeof from === "object") from = from.offsetTop;
  if (typeof to === "object") to = to.offsetTop;
  scrollToX(element, from, to, 0, 1 / duration, 20, easeOutCuaic);
}

function scrollToX(element, xFrom, xTo, t01, speed, step, motion) {
  if (t01 < 0 || t01 > 1 || speed <= 0) {
    element.scrollTop = xTo;
    return;
  }

  element.scrollTop = xFrom - (xFrom - xTo) * motion(t01);
  t01 += speed * step;
  setTimeout(function () {
    scrollToX(element, xFrom, xTo, t01, speed, step, motion);
  }, step);
}

function easeOutCuaic(t) {
  t--;
  return t * t * t + 1;
}

/***/ }),

/***/ 3200:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./src/scripts/vue/store/global.js

const store = vue_min_default().observable({
  menuActive: false,
  searchActive: false,
  notificationsActive: false,
  closeAnnouncement: false,
  customerCountry: 'NZ'
});
const actions = {
  openMenu() {
    store.menuActive = true;
  },

  toggleMenu() {
    if (store.menuActive) {
      this.closeAll();
    } else {
      this.closeAll();
      store.menuActive = true;
    }
  },

  toggleSearch() {
    store.searchActive = !store.searchActive;
  },

  toggleNotifications() {
    store.notificationsActive = !store.notificationsActive;
  },

  closeAll() {
    store.menuActive = false;
    store.searchActive = false;
    store.notificationsActive = false;
    window.PSTheme.Vue.Header.secondMenuIdx = null;
    window.PSTheme.Vue.Header.thirdMenuIdx = null;
  }

};
(vue_min_default()).prototype.$store = store;
(vue_min_default()).prototype.$actions = actions;
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
// EXTERNAL MODULE: ./node_modules/@vue/composition-api/dist/vue-composition-api.mjs
var vue_composition_api = __webpack_require__(5706);
// EXTERNAL MODULE: ./node_modules/vue-screen/dist/vue-screen.esm.js
var vue_screen_esm = __webpack_require__(6768);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/currency.js
var currency = __webpack_require__(1186);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-images/images.js
var theme_images_images = __webpack_require__(3253);
;// CONCATENATED MODULE: ./src/scripts/vue/main.js







/* config */

(vue_min_default()).config.devtools = true;
(vue_min_default()).config.productionTip = false;
(vue_min_default()).config.silent = true;
/* extensions */

(vue_min_default()).prototype.$language = globalThis.PSTheme.Language;
(vue_min_default()).prototype.$settings = globalThis.PSTheme.Settings;
(vue_min_default()).prototype.$customer = globalThis.PSTheme.Customer;

(vue_min_default()).prototype.$image = (src, size = '750x') => theme_images_images/* getSizedImageUrl */.M0(src, size);

(vue_min_default()).prototype.$preloadImages = (imgArray, size = '750x') => theme_images_images/* preload */.MA(imgArray, size);

(vue_min_default()).prototype.$money = amount => (0,currency/* formatMoney */.l)(amount, '${{amount}}');

(vue_min_default()).prototype.$isEmpty = obj => {
  if (obj && Object.keys(obj).length === 0 && obj.constructor === Object) return true;
};
/* plugins */


vue_min_default().use(vue_composition_api/* default */.ZP);
vue_min_default().use(vue_screen_esm/* default */.Z, {
  mobile_up: breakpoints/* px_breakpoints.--mobile-up */.ku["--mobile-up"],
  tablet_up: breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"],
  tablet_lg_up: breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"],
  laptop_up: breakpoints/* px_breakpoints.--laptop-up */.ku["--laptop-up"],
  desktop_up: breakpoints/* px_breakpoints.--desktop-up */.ku["--desktop-up"]
});

/***/ }),

/***/ 9982:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stub = __webpack_require__(5354);

var parse = __webpack_require__(4872);

var tracking = __webpack_require__(1235);

var ls = 'localStorage' in __webpack_require__.g && __webpack_require__.g.localStorage ? __webpack_require__.g.localStorage : stub;

function accessor(key, value) {
  if (arguments.length === 1) {
    return get(key);
  }

  return set(key, value);
}

function get(key) {
  const raw = ls.getItem(key);
  const parsed = parse(raw);
  return parsed;
}

function set(key, value) {
  try {
    ls.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    return false;
  }
}

function remove(key) {
  return ls.removeItem(key);
}

function clear() {
  return ls.clear();
}

function backend(store) {
  store && (ls = store);
  return ls;
}

accessor.set = set;
accessor.get = get;
accessor.remove = remove;
accessor.clear = clear;
accessor.backend = backend;
accessor.on = tracking.on;
accessor.off = tracking.off;
module.exports = accessor;

/***/ }),

/***/ 4872:
/***/ (function(module) {

"use strict";


function parse(rawValue) {
  const parsed = parseValue(rawValue);

  if (parsed === undefined) {
    return null;
  }

  return parsed;
}

function parseValue(rawValue) {
  try {
    return JSON.parse(rawValue);
  } catch (err) {
    return rawValue;
  }
}

module.exports = parse;

/***/ }),

/***/ 5354:
/***/ (function(module) {

"use strict";


var ms = {};

function getItem(key) {
  return key in ms ? ms[key] : null;
}

function setItem(key, value) {
  ms[key] = value;
  return true;
}

function removeItem(key) {
  var found = (key in ms);

  if (found) {
    return delete ms[key];
  }

  return false;
}

function clear() {
  ms = {};
  return true;
}

module.exports = {
  getItem: getItem,
  setItem: setItem,
  removeItem: removeItem,
  clear: clear
};

/***/ }),

/***/ 1235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var parse = __webpack_require__(4872);

var listeners = {};
var listening = false;

function listen() {
  if (__webpack_require__.g.addEventListener) {
    __webpack_require__.g.addEventListener('storage', change, false);
  } else if (__webpack_require__.g.attachEvent) {
    __webpack_require__.g.attachEvent('onstorage', change);
  } else {
    __webpack_require__.g.onstorage = change;
  }
}

function change(e) {
  if (!e) {
    e = __webpack_require__.g.event;
  }

  var all = listeners[e.key];

  if (all) {
    all.forEach(fire);
  }

  function fire(listener) {
    listener(parse(e.newValue), parse(e.oldValue), e.url || e.uri);
  }
}

function on(key, fn) {
  if (listeners[key]) {
    listeners[key].push(fn);
  } else {
    listeners[key] = [fn];
  }

  if (listening === false) {
    listen();
  }
}

function off(key, fn) {
  var ns = listeners[key];

  if (ns.length > 1) {
    ns.splice(ns.indexOf(fn), 1);
  } else {
    listeners[key] = [];
  }
}

module.exports = {
  on: on,
  off: off
};

/***/ }),

/***/ 7285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Accordion; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Accordion.vue?vue&type=template&id=77c46b6a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"accordion"},[_vm._t("default")],2)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Accordion.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var Accordionvue_type_script_lang_js_ = ({
  data() {
    return {
      Accordion: {
        count: 0,
        active: null
      }
    };
  },

  provide() {
    return {
      Accordion: this.Accordion
    };
  }

});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Accordion.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Accordionvue_type_script_lang_js_ = (Accordionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Accordion.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_Accordionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Accordion = (component.exports);

/***/ }),

/***/ 6398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AccordionItem; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/AccordionItem.vue?vue&type=template&id=1ed85426&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"accordion__item"},[_c('div',{class:[ 'accordion__item-question', { 'active': _vm.visible } ],on:{"click":_vm.open}},[_vm._t("accordion-question"),_vm._v(" "),_c('span',{staticClass:"icon-toggle icon--caret",class:{ 'active': _vm.visible }})],2),_vm._v(" "),_c('transition',{attrs:{"name":"accordion"},on:{"enter":_vm.start,"after-enter":_vm.end,"before-leave":_vm.start,"after-leave":_vm.end}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"accordion__item-answer"},[_vm._t("accordion-answer")],2)])],1)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/AccordionItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var AccordionItemvue_type_script_lang_js_ = ({
  inject: ['Accordion'],

  data() {
    return {
      index: null
    };
  },

  computed: {
    visible() {
      return this.index == this.Accordion.active;
    }

  },

  created() {
    this.index = this.Accordion.count++;

    if (this.index == 0) {
      this.Accordion.active = this.index;
    }
  },

  methods: {
    open() {
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }
    },

    start(el) {
      el.style.height = el.scrollHeight + 'px';
    },

    end(el) {
      el.style.height = '';
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/AccordionItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AccordionItemvue_type_script_lang_js_ = (AccordionItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/AccordionItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_AccordionItemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AccordionItem = (component.exports);

/***/ }),

/***/ 2347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Installments; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Installments.vue?vue&type=template&id=d9b6f562&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product__installments"},[(_vm.afterpay)?_c('div',{staticClass:"product__installments-wrapper"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAfterpay),expression:"showAfterpay"}],staticClass:"product__installments-text"},[_vm._v("\n      or 4x "),_c('strong',[_vm._v(_vm._s(_vm.$money(_vm.total / 4)))]),_vm._v(" fortnightly with\n      "),_c('img',{staticClass:"product__installments-image lazyload",attrs:{"data-src":"https://static.afterpay.com/integration/product-page/logo-afterpay-colour@2x.png","alt":"Afterpay"}})])]):_vm._e(),_vm._v(" "),(_vm.zip)?_c('div',{staticClass:"product__installments-wrapper"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showZip),expression:"showZip"}],staticClass:"product__installments-text"},[_vm._v("\n      or 4x "),_c('strong',[_vm._v(_vm._s(_vm.$money(_vm.total / 4)))]),_vm._v(" with\n      "),_c('img',{staticClass:"product__installments-image lazyload",attrs:{"data-src":"https://zip.co/nz/wp-content/uploads/2021/08/logo.svg","alt":"Zip"}})])]):_vm._e()])}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Installments.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Installmentsvue_type_script_lang_js_ = ({
  name: 'Installments',
  props: ['afterpay', 'zip', 'total'],
  computed: {
    showAfterpay() {
      return ['AU', 'NZ'].includes(this.$store.customerCountry);
    },

    showZip() {
      return ['AU', 'NZ', 'GB'].includes(this.$store.customerCountry);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Installments.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Installmentsvue_type_script_lang_js_ = (Installmentsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(3379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(9216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(4589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Installments.vue?vue&type=style&index=0&lang=css&
var Installmentsvue_type_style_index_0_lang_css_ = __webpack_require__(5723);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Installments.vue?vue&type=style&index=0&lang=css&

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(Installmentsvue_type_style_index_0_lang_css_/* default */.Z, options);




       /* harmony default export */ var components_Installmentsvue_type_style_index_0_lang_css_ = (Installmentsvue_type_style_index_0_lang_css_/* default */.Z && Installmentsvue_type_style_index_0_lang_css_/* default.locals */.Z.locals ? Installmentsvue_type_style_index_0_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/components/Installments.vue?vue&type=style&index=0&lang=css&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Installments.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_Installmentsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Installments = (component.exports);

/***/ }),

/***/ 9918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Loading; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[ 'site-loading', { 'activated': _vm.props.activated }],staticStyle:{"z-index":"100"}},[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"circle one"}),_vm._v(" "),_c('div',{staticClass:"circle two"})])}]


;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Loadingvue_type_script_lang_js_ = ({
  name: 'Loading',
  props: ['activated']
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Loadingvue_type_script_lang_js_ = (Loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_Loadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var Loading = (component.exports);

/***/ }),

/***/ 2095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductItem; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductItem.vue?vue&type=template&id=6fb0fe74&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"product-item",attrs:{"href":_vm.url,"title":("Product: " + _vm.title),"aria-label":("Product: " + _vm.title)}},[_c('div',{staticClass:"product-item__image-wrapper",staticStyle:{"--aspect-ratio":"0.65"},on:{"mouseover":function($event){_vm.hover = _vm.$screen.laptop_up},"mouseleave":function($event){_vm.hover = false}}},[_c('transition',{attrs:{"name":"fade"}},[_c('VImg',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeImage),expression:"activeImage"}],key:_vm.key,staticClass:"product-item__main-img",attrs:{"media":_vm.activeImage,"fixedSize":_vm.imageSize}})],1),_vm._v(" "),(_vm.hoverImage)?_c('VImg',{key:_vm.key,staticClass:"product-item__hover-img",attrs:{"media":_vm.hoverImage,"fixedSize":_vm.imageSize}}):_vm._e(),_vm._v(" "),(_vm.label || (_vm.hover && _vm.product.variants.length > 1))?_c('div',{staticClass:"product-item__label",style:(_vm.labelStyle)},[(_vm.hover && _vm.product.variants.length > 1)?_c('div',{staticClass:"product-item__variants"},_vm._l((_vm.product.variants),function(variant){return _c('span',{key:variant.id,class:{ disabled: !variant.available }},[_vm._v("\n          "+_vm._s(variant.title)+"\n        ")])}),0):_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"product-item__vendor"},[_vm._v("\n    "+_vm._s(_vm.product.vendor)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"product-item__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"product-item__price"},[_c('span',{domProps:{"textContent":_vm._s(_vm.$money(_vm.price))}}),_vm._v(" "),(_vm.salePrice)?_c('s',{staticClass:"product__price--sale",domProps:{"textContent":_vm._s(_vm.$money(_vm.salePrice))}}):_vm._e()]),_vm._v(" "),_c('div',{ref:"insert-wishlist",staticClass:"product-item__wishlist"})])}
var staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/vue/components/VImg.vue + 3 modules
var VImg = __webpack_require__(3133);
// EXTERNAL MODULE: ./src/scripts/vue/components/Loading.vue + 4 modules
var Loading = __webpack_require__(9918);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ProductItemvue_type_script_lang_js_ = ({
  name: 'ProductItem',
  components: {
    VImg: VImg/* default */.Z,
    Loading: Loading/* default */.Z
  },
  props: ['product', 'collection', 'label_conf'],

  data() {
    return {
      key: 0,
      hover: false,
      lazyloaded: 0,
      imageSize: '550x'
    };
  },

  computed: {
    title() {
      return this.product.title.replace(this.product.vendor, '').trim();
    },

    handle() {
      return this.product.handle;
    },

    url() {
      return typeof this.collection !== 'undefined' ? `/collections/${this.collection}/products/${this.handle}` : `/products/${this.handle}`;
    },

    price() {
      return this.product.price;
    },

    salePrice() {
      return this.product.variants[0].compare_at_price;
    },

    productImages() {
      const images = this.product.media.filter( // eslint-disable-next-line camelcase
      ({
        media_type
      }) => media_type === 'image');
      return images;
    },

    images() {
      return this.product.images_info || this.productImages;
    },

    activeImage() {
      if (this.images.length === 0) return window.PSTheme.Settings.NoImage;
      return this.images[0];
    },

    hoverImage() {
      if (this.images.length > 1) return this.images[1];
      return null;
    },

    tags() {
      return this.product.tags;
      let temp_tags = this.product.tags;

      if (Array.isArray(temp_tags)) {
        return [...temp_tags].reverse();
        ;
      } else {
        return temp_tags;
      }
    },

    label() {
      if (window.PSTheme.Settings.Outlet && this.salePrice) {
        const discount = Math.round(100 - 100 * (this.price / this.salePrice));
        return `${discount}% off`;
      }

      let label = this.tags ? this.tags.find(tag => tag.includes('Label:')) : '';

      if (label) {
        label = label.replace('Label: ', '');
        label = label.charAt(0).toUpperCase() + label.slice(1);
        return label;
      }
    },

    labelStyle() {
      const conf = this.label_conf ? this.label_conf[this.label] : null;
      const defaultStyle = window.PSTheme.Settings.Outlet ? 'color: var(--red); background: var(--soft-pink);' : 'color: var(--sage); background: var(--mint);';
      return conf ? `color: ${conf.color}; background: ${conf.background};` : defaultStyle;
    }

  },

  created() {
    const preloadImages = [];
    const images = this.images.filter( // eslint-disable-next-line camelcase
    ({
      media_type
    }) => media_type === 'image');
    if (images) preloadImages.push(images[0].src ? images[0].src : images[0]);
    if (images.length > 1) preloadImages.push(images[1].src ? images[1].src : images[1]);
    this.$preloadImages(preloadImages, this.imageSize);
  },

  mounted() {
    if (window.PSTheme.Settings.Outlet === false) {
      const wishlist_btn = document.createComment(` include 'wishlist-button-collection' with '${this.product.id}' `);
      this.$refs['insert-wishlist'].appendChild(wishlist_btn);
    }
  },

  watch: {
    // re-render the template programmatically
    activeImage: {
      handler() {
        this.key = Math.random() * (999 - 0 + 1) << 0;
      },

      deep: true
    }
  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ProductItemvue_type_script_lang_js_ = (ProductItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_ProductItemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductItem = (component.exports);

/***/ }),

/***/ 3133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VImg; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=template&id=4a5ed573&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vimg",class:_vm.customClass,attrs:{"src":_vm.fixedSize ? _vm.$image(_vm.media.src, _vm.fixedSize) : _vm.$image(_vm.media.src),"srcset":_vm.fixedSize ? '' : _vm.srcset,"data-sizes":"auto","alt":_vm.media.alt || _vm.$attrs.alt || 'Image',"loading":_vm.loading_method || 'lazy'}})}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VImgvue_type_script_lang_js_ = ({
  name: 'VImg',
  props: ['media', 'fixedSize', 'customClass', 'loading_method'],
  computed: {
    srcset() {
      if (this.fixedSize) return null;
      const {
        src,
        width
      } = this.media;
      const srcset = `${this.$image(src, '200x')} 100w'
      ${width >= 200 ? `, ${this.$image(src, '400x')} 200w` : ''}
      ${width >= 400 ? `, ${this.$image(src, '800x')} 400w` : ''}
      ${width >= 600 ? `, ${this.$image(src, '1200x')} 600w` : ''}
      ${width >= 800 ? `, ${this.$image(src, '1600x')} 800w` : ''}
      ${width >= 1000 ? `, ${this.$image(src, '2000x')} 1000w` : ''}
      ${width >= 1500 ? `, ${this.$image(src, '3000x')} 1500w` : ''}
      ${width >= 2000 ? `, ${this.$image(src, '4000x')} 2000w` : ''}`;
      return srcset;
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VImgvue_type_script_lang_js_ = (VImgvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_VImgvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VImg = (component.exports);

/***/ }),

/***/ 6903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Product; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/templates/Product.vue?vue&type=template&id=5f62df90&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('div',{staticClass:"product-wrapper"},[_c('div',{staticClass:"product__container"},[_c('aside',{staticClass:"product__gallery"},[(_vm.product.type !== 'GIFT CARD')?_c('Gallery',{attrs:{"media":_vm.product.media,"images":_vm.product.images}}):_c('div',{staticClass:"product__gallery-giftcard"},[_c('VImg',{attrs:{"media":_vm.product.media[0]}})],1)],1),_vm._v(" "),_c('div',{staticClass:"product__details"},[_c('div',{staticClass:"product__details-header"},[_c('h1',[_vm._v("\n          "+_vm._s(_vm.product.title)+"\n          "),(_vm.label)?_c('span',{staticClass:"product__details-header--label",style:(_vm.labelStyle)},[_vm._v("\n            "+_vm._s(_vm.label)+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"product__details-price"},[_c('p',{staticClass:"product__price"},[_c('span',{domProps:{"textContent":_vm._s(_vm.$money(_vm.price))}}),_vm._v(" "),(_vm.salePrice)?_c('s',{staticClass:"product__price--sale",domProps:{"textContent":_vm._s(_vm.$money(_vm.salePrice))}}):_vm._e()]),_vm._v(" "),_c('Installments',{attrs:{"afterpay":true,"zip":true,"total":_vm.price}})],1),_vm._v(" "),_c('ProductForm',{attrs:{"options":_vm.product.options,"variants":_vm.product.variants,"activeVariant":_vm.activeVariant,"hasDefaultVariant":_vm.has_default_variant,"available":_vm.activeVariant.available},on:{"update:variant":function($event){return _vm.updateVariant($event)}}}),_vm._v(" "),_c('span',{staticStyle:{"display":"none"},attrs:{"id":"strut-fit-shoeId"}},[_vm._v(_vm._s(_vm.product.id))]),_vm._v(" "),_c('span',{staticStyle:{"display":"none"},attrs:{"id":"strut-fit-orgId"}},[_vm._v("28")]),_vm._v(" "),_c('div',{attrs:{"id":"strutfit-app"}}),_vm._v(" "),(_vm.product.tags.includes('Label: Final Sale'))?_c('p',{staticClass:"product__details-message"},[_vm._v("\n        This item is non-returnable\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"product__details-description"},[_c('div',{staticClass:"rte",domProps:{"innerHTML":_vm._s(_vm.product.description)}})]),_vm._v(" "),_c('div',{staticClass:"product__details-socials",domProps:{"innerHTML":_vm._s(_vm.socials_html)}})],1)]),_vm._v(" "),_c('div',{staticClass:"okeReviews-widget-holder"},[_c('div',{staticClass:"okeReviews-customHeader"},[_c('div',{staticClass:"okeReviews-customHeader-left"},[_c('h1',[_vm._v("REVIEWS")]),_vm._v(" "),_c('div',{staticClass:"okeReviews okeReviews--theme",attrs:{"data-oke-reviews-product-listing-rating":"","data-oke-reviews-product-id":_vm.productId}})]),_vm._v(" "),_c('div',{staticClass:"okeReviews-customHeader-right"},[(!_vm.$settings.Outlet)?_c('a',{staticClass:"okeReviews-reviewsWidget-header-controls-writeReview js-okeReviews-writeReview okeReviews-button",attrs:{"target":"_blank","tabindex":"0","rel":"nofollow","data-oke-ga-click-action":"Write Review Click","href":_vm.writeReviewUrl}},[_vm._v("\n          Write a Review\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"okeReviews-carouselWrapper"},[_c('div',{attrs:{"data-oke-reviews-widget":"","data-oke-reviews-slides-small":"2","data-oke-reviews-slides-medium":"3","data-oke-reviews-slides-large":"4","data-oke-reviews-product-id":_vm.productId}}),_vm._v(" "),(!_vm.$settings.Outlet)?_c('div',{staticClass:"okeReviews-incentiveBlock"},[_c('div',{staticClass:"okeReviews-incentiveBlock-text"},[_vm._v("\n          Write a review, get 100 Shine On points\n        ")])]):_vm._e()])]),_vm._v(" "),(_vm.settings && _vm.metafields)?_c(_vm.$screen.tablet_lg_up
        ? 'ProductPeripheralBoxes'
        : 'ProductPeripheralAccordion',{tag:"component",attrs:{"settings":_vm.settings,"metafields":_vm.metafields,"tags":_vm.product.tags}}):_vm._e(),_vm._v(" "),(_vm.collection_images)?_c('div',{staticClass:"product__more-in-this-collection"},[_c('a',{staticClass:"more-in-this-collection__images",attrs:{"href":("/collections/" + _vm.collection_handle),"aria-label":"More from this collection"}},_vm._l((_vm.collection_images),function(image,idx){return _c('div',{key:idx,staticClass:"more-in-this-collection__image"},[_c('img',{staticClass:"lazyload",attrs:{"data-src":_vm.$screen.tablet_lg_up
              ? _vm.$image(image, '850x')
              : _vm.$image(image, '450x'),"alt":"Collection image"}})])}),0),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),_c('Recommended',{attrs:{"id":_vm.product.id}}),_vm._v(" "),_c('AlsoViewed',{attrs:{"handle":_vm.handle}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-text-wrapper vert-center hor-center"},[_c('i',{staticClass:"small--signature signature"},[_vm._v("More")]),_vm._v(" "),_c('h2',{staticClass:"small--text"},[_vm._v("IN THIS COLLECTION")])])}]


;// CONCATENATED MODULE: ./src/scripts/vue/templates/Product.vue?vue&type=template&id=5f62df90&

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Gallery.vue?vue&type=template&id=a9400448&
var Galleryvue_type_template_id_a9400448_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery",class:{ loaded: _vm.featuredLazyLoaded }},[_c('div',{staticClass:"gallery__thumbnails"},[_c('Slider',{ref:"thumbnails",attrs:{"options":_vm.thumbnailOptions}},_vm._l((_vm.media),function(media,idx){return _c('Slide',{key:idx,staticClass:"slide--thumbnail",staticStyle:{"--aspect-ratio":"2/3"}},[(media.media_type == 'video')?_c('div',{ref:"div",refInFor:true,staticClass:"video-thumb"},[_c('VImg',{attrs:{"media":media.preview_image,"fixedSize":"250x","alt":"Gallery Thumbnail"}}),_vm._v(" "),_c('PlayIcon')],1):_c('VImg',{attrs:{"media":media,"fixedSize":"250x","alt":"Gallery Thumbnail"}})],1)}),1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.toShow > 0 && _vm.images.length > 4),expression:"toShow > 0 && images.length > 4"}],staticClass:"gallery__showmore"},[_vm._v("\n      "+_vm._s(("+" + _vm.toShow + " more images"))+"\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"gallery__main"},[_c('Slider',{ref:"gallery",attrs:{"options":_vm.galleryOptions},on:{"splide:moved":_vm.onMoved,"splide:mounted":_vm.onMoved}},_vm._l((_vm.media),function(media,idx){return _c('Slide',{key:idx,staticClass:"slide--main"},[(media.media_type == 'video')?_c('div',{staticClass:"video-wrapper"},[_c('video',{staticClass:"lazyload",attrs:{"preload":"none","muted":"","loop":"","playsinline":"","autoplay":"","data-poster":media.preview_image.src,"loading":idx === 0 ? 'eager' : 'lazy'},domProps:{"muted":true}},[_c('source',{key:idx,attrs:{"src":_vm.videoSourceURL(media.sources)}}),_vm._v("\n            Sorry, your browser doesn't support embedded videos.\n          ")])]):_c('div',{staticClass:"image-wrapper",on:{"mousemove":function($event){return _vm.zoom($event, media)}}},[_c('VImg',{attrs:{"media":media,"alt":"Gallery Main","loading_method":idx === 0 ? 'eager' : 'lazy'}})],1)])}),1)],1)])}
var Galleryvue_type_template_id_a9400448_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/@splidejs/vue-splide/src/js/index.js + 9 modules
var js = __webpack_require__(5493);
// EXTERNAL MODULE: ./src/scripts/vue/components/VImg.vue + 3 modules
var VImg = __webpack_require__(3133);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/icons/PlayIcon.vue?vue&type=template&id=fe28ac4e&functional=true&
var PlayIconvue_type_template_id_fe28ac4e_functional_true_render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 512 512"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","xml:space":"preserve"}},[_c('path',{attrs:{"fill":"#E2CEBD","d":"M256 0C114.833 0 0 114.844 0 256s114.833 256 256 256 256-114.844 256-256S397.167 0 256 0zm101.771 264.969-149.333 96a10.62 10.62 0 0 1-5.771 1.698c-1.75 0-3.521-.438-5.104-1.302A10.653 10.653 0 0 1 192 352V160c0-3.906 2.125-7.49 5.563-9.365 3.375-1.854 7.604-1.74 10.875.396l149.333 96c3.042 1.958 4.896 5.344 4.896 8.969s-1.854 7.01-4.896 8.969z"}})])}
var PlayIconvue_type_template_id_fe28ac4e_functional_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/icons/PlayIcon.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var PlayIconvue_type_script_lang_js_ = ({
  name: 'PlayIcon'
});
;// CONCATENATED MODULE: ./src/scripts/vue/icons/PlayIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var icons_PlayIconvue_type_script_lang_js_ = (PlayIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/icons/PlayIcon.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  icons_PlayIconvue_type_script_lang_js_,
  PlayIconvue_type_template_id_fe28ac4e_functional_true_render,
  PlayIconvue_type_template_id_fe28ac4e_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var PlayIcon = (component.exports);
// EXTERNAL MODULE: ./src/scripts/vue/components/Loading.vue + 4 modules
var Loading = __webpack_require__(9918);
// EXTERNAL MODULE: ./node_modules/@splidejs/splide/dist/css/themes/splide-default.min.css
var splide_default_min = __webpack_require__(881);
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Gallery.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Galleryvue_type_script_lang_js_ = ({
  name: 'Gallery',
  components: {
    VImg: VImg/* default */.Z,
    PlayIcon: PlayIcon,
    Loading: Loading/* default */.Z,
    Slider: js/* Splide */.tv,
    Slide: js/* SplideSlide */.jw
  },
  props: ['media', 'images'],

  data() {
    return {
      galleryOptions: {
        pagination: false,
        breakpoints: {
          [breakpoints/* px_breakpoints.--laptop-up */.ku["--laptop-up"]]: {
            pagination: true
          }
        }
      },
      thumbnailOptions: {
        height: '40rem',
        fixedHeight: '9rem',
        gap: '1rem',
        direction: 'ttb',
        drag: false,
        perPage: 4,
        perMove: 1,
        pagination: false,
        isNavigation: true,
        breakpoints: {
          [breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"]]: {
            destroy: false
          },
          [breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"]]: {
            destroy: true
          }
        }
      },
      featuredLazyLoaded: false,
      toShow: 0
    };
  },

  mounted() {
    // Syncing the two sliders together so that when you click on a thumbnail, the main slider
    // will move to the corresponding image.
    this.$refs.gallery.sync(this.$refs.thumbnails.splide);
    document.querySelector('.gallery');
    this.$preloadImages(this.images, '750x');
  },

  methods: {
    zoom(event, media) {
      if (this.$screen.laptop_up) {
        const zoomer = event.currentTarget;
        zoomer.style.backgroundImage = `url(${media.src})`;
        let offsetX = 0;
        let offsetY = 0;
        event.offsetX ? offsetX = event.offsetX : offsetX = event.touches[0].pageX;
        event.offsetY ? offsetY = event.offsetY : offsetX = event.touches[0].pageX;
        const x = offsetX / zoomer.offsetWidth * 100;
        const y = offsetY / zoomer.offsetHeight * 100;
        zoomer.style.backgroundPosition = `${x}% ${y}%`;
      }
    },

    // Finding the highest quality video source.
    videoSourceURL(sources) {
      let ten80;
      let seven20;
      let four80 = false;

      for (const source of sources) {
        if (source.url.includes('1080p')) ten80 = source.url;
        if (source.url.includes('720p')) seven20 = source.url;
        if (source.url.includes('480p')) four80 = source.url;
      }

      return ten80 || seven20 || four80 || sources.pop().url;
    },

    // It's a method that is called when the gallery is moved. It's used to calculate how many more images
    // are left to show.
    onMoved() {
      this.toShow = this.$refs.gallery.splide.length - this.$refs.gallery.splide.index - 1;
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Gallery.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Galleryvue_type_script_lang_js_ = (Galleryvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/Gallery.vue





/* normalize component */
;
var Gallery_component = (0,componentNormalizer/* default */.Z)(
  components_Galleryvue_type_script_lang_js_,
  Galleryvue_type_template_id_a9400448_render,
  Galleryvue_type_template_id_a9400448_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Gallery = (Gallery_component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductForm.vue?vue&type=template&id=13b03b4b&
var ProductFormvue_type_template_id_13b03b4b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",staticClass:"product__details-form",attrs:{"method":"post","action":"/cart/add","accept-charset":"UTF-8","enctype":"multipart/form-data"}},[_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.activeVariant.id ? _vm.activeVariant.id : ''}}),_vm._v(" "),(!_vm.hasDefaultVariant)?[(_vm.options.length == 1)?_c('div',[_c('div',{staticClass:"product__form-option"},[_c('span',{staticClass:"option__name"},[_vm._v("Pick Your "+_vm._s(_vm.options[0])+":")]),_vm._v(" "),_c('div',{staticClass:"option__values"},_vm._l((_vm.variants),function(variant){return _c('label',{key:variant.id,class:['option__label', { disabled: !variant.available }],attrs:{"for":("option-" + (variant.id))}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOptions['option1']),expression:"selectedOptions['option1']"}],attrs:{"type":"radio","id":("option-" + (variant.id))},domProps:{"value":variant.title,"checked":_vm._q(_vm.selectedOptions['option1'],variant.title)},on:{"change":[function($event){return _vm.$set(_vm.selectedOptions, 'option1', variant.title)},function($event){return _vm.onOptionChange()}]}}),_vm._v(" "),_c('span',{staticClass:"option__button"},[_vm._v("\n              "+_vm._s(variant.title.replace('.00', ''))+"\n            ")])])}),0)])]):_c('div',_vm._l((_vm.options),function(option){return _c('div',{key:option.id,staticClass:"product__form-option"},[_c('span',{staticClass:"option__name"},[_vm._v("Pick Your "+_vm._s(option.name)+":")]),_vm._v(" "),_c('div',{staticClass:"option__values"},_vm._l((option.values),function(value,idx){return _c('label',{key:idx,staticClass:"option__label",attrs:{"for":("option-" + (option.name) + "-" + idx)}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOptions[("option" + (option.position))]),expression:"selectedOptions[`option${option.position}`]"}],attrs:{"type":"radio","id":("option-" + (option.name) + "-" + idx)},domProps:{"value":value,"checked":_vm._q(_vm.selectedOptions[("option" + (option.position))],value)},on:{"change":[function($event){return _vm.$set(_vm.selectedOptions, ("option" + (option.position)), value)},function($event){return _vm.onOptionChange()}]}}),_vm._v(" "),_c('span',{staticClass:"option__button"},[_vm._v("\n              "+_vm._s(value)+"\n            ")])])}),0)])}),0)]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"product__form-buttons"},[_c('button',{staticClass:"btn btn--primary",class:{ 'product__form-added-to-cart': _vm.added },attrs:{"disabled":!_vm.activeVariant || !_vm.available},domProps:{"textContent":_vm._s(_vm.added ? _vm.successText : _vm.addToCartText)},on:{"click":function($event){$event.preventDefault();return _vm.addToCart(_vm.activeVariant.id)}}}),_vm._v(" "),_c('div',{ref:"insert-wishlist"})])],2)}
var ProductFormvue_type_template_id_13b03b4b_staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/utils/cart.js
var cart = __webpack_require__(7342);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/icons/BagIcon.vue?vue&type=template&id=b7585184&functional=true&
var BagIconvue_type_template_id_b7585184_functional_true_render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"width":"24","height":"22","viewBox":"0 0 20 21","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke":"#000","stroke-width":"1.35","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M4.786 7.238H14.84a1.62 1.62 0 0 1 1.598 1.354l1.574 9.46a1.62 1.62 0 0 1-1.598 1.886H3.094a1.62 1.62 0 0 1-1.595-1.906l1.692-9.459a1.62 1.62 0 0 1 1.595-1.335z"}}),_c('path',{attrs:{"d":"M6.508 10.168C6.588 4.056 7.718 1 9.898 1s3.26 3.056 3.24 9.168"}})])])}
var BagIconvue_type_template_id_b7585184_functional_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/icons/BagIcon.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var BagIconvue_type_script_lang_js_ = ({
  name: 'BagIcon'
});
;// CONCATENATED MODULE: ./src/scripts/vue/icons/BagIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var icons_BagIconvue_type_script_lang_js_ = (BagIconvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/icons/BagIcon.vue





/* normalize component */
;
var BagIcon_component = (0,componentNormalizer/* default */.Z)(
  icons_BagIconvue_type_script_lang_js_,
  BagIconvue_type_template_id_b7585184_functional_true_render,
  BagIconvue_type_template_id_b7585184_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var BagIcon = (BagIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductForm.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ProductFormvue_type_script_lang_js_ = ({
  name: 'ProductForm',
  components: {
    BagIcon: BagIcon
  },
  props: ['options', 'variants', 'available', 'activeVariant', 'hasDefaultVariant'],
  computed: {
    addToCartText() {
      if (this.activeVariant.id) {
        return this.available ? this.$language.product.add_to_cart : this.$language.product.sold_out;
      } else {
        return 'Pick Your Size';
      }
    },

    successText() {
      return this.$language.product.add_to_cart_success;
    }

  },

  data() {
    return {
      added: false,
      selectedOptions: {
        option1: '',
        option2: '',
        option3: ''
      }
    };
  },

  mounted() {
    // Create a comment for the wishlist app to observe
    if (window.PSTheme.Settings.Outlet === false) {
      const wishlist_btn = document.createComment(` include 'wishlist-button-product' with '${this.$parent.product.id}' `);
      this.$refs['insert-wishlist'].appendChild(wishlist_btn);
    }
  },

  methods: {
    onOptionChange() {
      this.updateVariant();
    },

    updateVariant() {
      // Updating the variant based on the selected options
      const opt_length = this.options.length;
      this.variants.forEach(variant => {
        if (opt_length == 1 && this.selectedOptions.option1 == variant.option1) {
          this.$emit('update:variant', variant);
        } else if (opt_length == 2 && this.selectedOptions.option1 == variant.option1 && this.selectedOptions.option2 == variant.option2) {
          this.$emit('update:variant', variant);
        } else if (this.selectedOptions.option1 == variant.option1 && this.selectedOptions.option2 == variant.option2 && this.selectedOptions.option3 == variant.option3) {
          this.$emit('update:variant', variant);
        }
      });
    },

    addToCart(vID) {
      (0,cart/* addItem */.jX)(vID).then(() => {
        this.added = true;
        window.PSTheme.Vue.Header.updateCartCount(1);
        setTimeout(() => {
          this.added = false;
        }, 2000);
      });
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductForm.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ProductFormvue_type_script_lang_js_ = (ProductFormvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductForm.vue





/* normalize component */
;
var ProductForm_component = (0,componentNormalizer/* default */.Z)(
  components_ProductFormvue_type_script_lang_js_,
  ProductFormvue_type_template_id_13b03b4b_render,
  ProductFormvue_type_template_id_13b03b4b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductForm = (ProductForm_component.exports);
// EXTERNAL MODULE: ./src/scripts/vue/components/Installments.vue + 5 modules
var Installments = __webpack_require__(2347);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductPeripheralBoxes.vue?vue&type=template&id=491acac6&
var ProductPeripheralBoxesvue_type_template_id_491acac6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sizingInformation || _vm.materials || _vm.stylingTip)?_c('div',{staticClass:"product__peripherals"},[(_vm.sizingInformation)?_c('div',{staticClass:"product__peripherals-box size-info"},[_c('h6',{staticClass:"peripherals-box__title"},[_vm._v("SIZING INFORMATION")]),_vm._v(" "),_c('div',{staticClass:"peripherals-box__content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sizingInformation.html)}})])]):_vm._e(),_vm._v(" "),(_vm.materials)?_c('div',{staticClass:"product__peripherals-box composition"},[_c('h6',{staticClass:"peripherals-box__title"},[_vm._v("\n      COMPOSITION\n    ")]),_vm._v(" "),_c('div',{staticClass:"peripherals-box__content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.materials.html)}})])]):_vm._e(),_vm._v(" "),(_vm.stylingTip)?_c('div',{staticClass:"product__peripherals-box style-tip"},[_c('h6',{staticClass:"peripherals-box__title"},[_vm._v("STYLING TIP")]),_vm._v(" "),_c('div',{staticClass:"peripherals-box__content"},[_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.stylingTip.html)}}),_vm._v(" "),(_vm.stylingTipProduct)?_c('a',{staticClass:"peripherals-box__product",attrs:{"href":_vm.stylingTipProduct.url}},[_c('img',{staticClass:"lazyload",attrs:{"data-src":_vm.$image(_vm.stylingTipProduct.featured_image, '150x'),"alt":_vm.stylingTipProduct.title}}),_vm._v(" "),_c('i',[_vm._v("Perfect match")]),_vm._v(" "),_c('button',{staticClass:"btn--small"},[_vm._v("\n            "+_vm._s(_vm.stylingTipProduct.title)+"\n          ")])]):_vm._e()])])]):_vm._e()]):_vm._e()}
var ProductPeripheralBoxesvue_type_template_id_491acac6_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductPeripheralBoxes.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var ProductPeripheralBoxesvue_type_script_lang_js_ = ({
  name: 'ProductPeripheralBoxes',
  props: ['settings', 'metafields', 'tags'],

  data() {
    return {
      stylingTipProduct: null
    };
  },

  computed: {
    sizingInformation() {
      return this.metafields.sizing_information;
    },

    materials() {
      return this.metafields.materials;
    },

    stylingTip() {
      return this.metafields.styling_tip;
    }

  },

  mounted() {
    if (this.metafields.styling_tip_product) {
      fetch(`/products/${this.metafields.styling_tip_product}.js`).then(res => res.json()).then(product => {
        this.stylingTipProduct = product;
      });
    }
  }

});
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductPeripheralBoxes.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ProductPeripheralBoxesvue_type_script_lang_js_ = (ProductPeripheralBoxesvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductPeripheralBoxes.vue



;


/* normalize component */

var ProductPeripheralBoxes_component = (0,componentNormalizer/* default */.Z)(
  components_ProductPeripheralBoxesvue_type_script_lang_js_,
  ProductPeripheralBoxesvue_type_template_id_491acac6_render,
  ProductPeripheralBoxesvue_type_template_id_491acac6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductPeripheralBoxes = (ProductPeripheralBoxes_component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductPeripheralAccordion.vue?vue&type=template&id=58fee666&scoped=true&
var ProductPeripheralAccordionvue_type_template_id_58fee666_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sizingInformation || _vm.materials || _vm.stylingTip)?_c('Accordion',{staticClass:"peripheral-accordion"},[(_vm.sizingInformation)?_c('AccordionItem',{staticClass:"peripheral-accordion__item size-info"},[_c('template',{staticClass:"peripheral-accordion__item-question",slot:"accordion-question"},[_c('h6',{staticClass:"peripherals-box__title"},[_vm._v("SIZING INFORMATION")])]),_vm._v(" "),_c('template',{slot:"accordion-answer"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sizingInformation.html)}})])],2):_vm._e(),_vm._v(" "),(_vm.materials)?_c('AccordionItem',{staticClass:"peripheral-accordion__item composition"},[_c('template',{staticClass:"peripheral-accordion__item-question",slot:"accordion-question"},[_c('h6',{staticClass:"peripherals-box__title"},[_vm._v("COMPOSITION")])]),_vm._v(" "),_c('template',{slot:"accordion-answer"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.materials.html)}})])],2):_vm._e(),_vm._v(" "),(_vm.stylingTip)?_c('AccordionItem',{staticClass:"peripheral-accordion__item style-tip"},[_c('template',{staticClass:"peripheral-accordion__item-question",slot:"accordion-question"},[_c('h6',{staticClass:"peripherals-box__title"},[_vm._v("STYLING TIP")])]),_vm._v(" "),_c('template',{slot:"accordion-answer"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.stylingTip.html)}}),_vm._v(" "),(_vm.stylingTipProduct)?_c('a',{staticClass:"peripherals-box__product",attrs:{"href":_vm.stylingTipProduct.url}},[_c('img',{staticClass:"lazyload",attrs:{"data-src":_vm.$image(_vm.stylingTipProduct.featured_image, '150x'),"alt":_vm.stylingTipProduct.title}}),_vm._v(" "),_c('i',[_vm._v("Perfect match")]),_vm._v(" "),_c('button',{staticClass:"btn--small"},[_vm._v("\n          "+_vm._s(_vm.stylingTipProduct.title)+"\n        ")])]):_vm._e()])],2):_vm._e()],1):_vm._e()}
var ProductPeripheralAccordionvue_type_template_id_58fee666_scoped_true_staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/vue/components/Accordion.vue + 3 modules
var Accordion = __webpack_require__(7285);
// EXTERNAL MODULE: ./src/scripts/vue/components/AccordionItem.vue + 3 modules
var AccordionItem = __webpack_require__(6398);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductPeripheralAccordion.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ProductPeripheralAccordionvue_type_script_lang_js_ = ({
  name: 'ProductPeripheralAccordion',
  components: {
    Accordion: Accordion/* default */.Z,
    AccordionItem: AccordionItem/* default */.Z
  },
  props: ['settings', 'metafields', 'tags'],

  data() {
    return {
      stylingTipProduct: null
    };
  },

  computed: {
    sizingInformation() {
      return this.metafields.sizing_information;
    },

    materials() {
      return this.metafields.materials;
    },

    stylingTip() {
      return this.metafields.styling_tip;
    }

  },

  mounted() {
    if (this.metafields.styling_tip_product) {
      fetch(`/products/${this.metafields.styling_tip_product}.js`).then(res => res.json()).then(product => {
        this.stylingTipProduct = product;
      });
    }
  }

});
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductPeripheralAccordion.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ProductPeripheralAccordionvue_type_script_lang_js_ = (ProductPeripheralAccordionvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductPeripheralAccordion.vue



;


/* normalize component */

var ProductPeripheralAccordion_component = (0,componentNormalizer/* default */.Z)(
  components_ProductPeripheralAccordionvue_type_script_lang_js_,
  ProductPeripheralAccordionvue_type_template_id_58fee666_scoped_true_render,
  ProductPeripheralAccordionvue_type_template_id_58fee666_scoped_true_staticRenderFns,
  false,
  null,
  "58fee666",
  null
  
)

/* harmony default export */ var ProductPeripheralAccordion = (ProductPeripheralAccordion_component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Recommended.vue?vue&type=template&id=bcc67906&v-if=recommendedProducts.length%20%3E%200&
var Recommendedvue_type_template_id_bcc67906_v_if_recommendedProducts_length_20_3E_200_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"product__recommended"},[_c('h1',[_vm._v(_vm._s(_vm.$language.product.recommended))]),_vm._v(" "),_c('div',{staticClass:"product-grid"},_vm._l((_vm.recommendedProducts),function(product){return _c('ProductItem',{key:product.id,attrs:{"product":product}})}),1)])}
var Recommendedvue_type_template_id_bcc67906_v_if_recommendedProducts_length_20_3E_200_staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/vue/components/ProductItem.vue + 3 modules
var ProductItem = __webpack_require__(2095);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Recommended.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Recommendedvue_type_script_lang_js_ = ({
  name: 'Recommended',
  components: {
    ProductItem: ProductItem/* default */.Z
  },
  props: ['id'],

  data() {
    return {
      recommendedProducts: []
    };
  },

  created() {
    fetch(`/recommendations/products.json?product_id=${this.id}&limit=6`).then(res => res.json()).then(({
      products
    }) => this.recommendedProducts = products);
  }

});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Recommended.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Recommendedvue_type_script_lang_js_ = (Recommendedvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(3379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(9216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(4589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Recommended.vue?vue&type=style&index=0&lang=css&
var Recommendedvue_type_style_index_0_lang_css_ = __webpack_require__(3747);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Recommended.vue?vue&type=style&index=0&lang=css&

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(Recommendedvue_type_style_index_0_lang_css_/* default */.Z, options);




       /* harmony default export */ var components_Recommendedvue_type_style_index_0_lang_css_ = (Recommendedvue_type_style_index_0_lang_css_/* default */.Z && Recommendedvue_type_style_index_0_lang_css_/* default.locals */.Z.locals ? Recommendedvue_type_style_index_0_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/components/Recommended.vue?vue&type=style&index=0&lang=css&

;// CONCATENATED MODULE: ./src/scripts/vue/components/Recommended.vue



;


/* normalize component */

var Recommended_component = (0,componentNormalizer/* default */.Z)(
  components_Recommendedvue_type_script_lang_js_,
  Recommendedvue_type_template_id_bcc67906_v_if_recommendedProducts_length_20_3E_200_render,
  Recommendedvue_type_template_id_bcc67906_v_if_recommendedProducts_length_20_3E_200_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Recommended = (Recommended_component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/AlsoViewed.vue?vue&type=template&id=ca2a808a&v-if=viewedProducts.length%20%3E%200&
var AlsoViewedvue_type_template_id_ca2a808a_v_if_viewedProducts_length_20_3E_200_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"product__also-viewed"},[_c('h1',[_vm._v(_vm._s(_vm.$language.product.also_viewed))]),_vm._v(" "),_c('div',{staticClass:"product-grid"},_vm._l((_vm.viewedProducts.slice(0, 6)),function(product){return _c('ProductItem',{key:product.id,attrs:{"product":product}})}),1)])}
var AlsoViewedvue_type_template_id_ca2a808a_v_if_viewedProducts_length_20_3E_200_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/local-storage/local-storage.js
var local_storage = __webpack_require__(9982);
var local_storage_default = /*#__PURE__*/__webpack_require__.n(local_storage);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/AlsoViewed.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var AlsoViewedvue_type_script_lang_js_ = ({
  name: 'AlsoViewed',
  components: {
    ProductItem: ProductItem/* default */.Z
  },
  props: ['handle'],

  data() {
    return {
      viewedProducts: []
    };
  },

  mounted() {
    this.setViewedProducts();

    if (local_storage_default()('PSProductsViewed')) {
      this.createViewedProducts();
    }
  },

  methods: {
    setViewedProducts() {
      let viewedHistory = local_storage_default()('PSProductsViewed') || [];
      if (viewedHistory.includes(this.handle)) return;
      if (viewedHistory.length > 6) viewedHistory.pop();
      viewedHistory.unshift(this.handle);
      local_storage_default()('PSProductsViewed', viewedHistory);
    },

    async createViewedProducts() {
      let productHandles = local_storage_default()('PSProductsViewed');

      for (const handle of productHandles) {
        if (handle == this.handle) continue;
        await fetch(`/products/${handle}.js`).then(res => res.json()).then(product => {
          this.viewedProducts.push({ ...product
          });
        });
      }
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/AlsoViewed.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AlsoViewedvue_type_script_lang_js_ = (AlsoViewedvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/AlsoViewed.vue?vue&type=style&index=0&lang=css&
var AlsoViewedvue_type_style_index_0_lang_css_ = __webpack_require__(9305);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/AlsoViewed.vue?vue&type=style&index=0&lang=css&

      
      
      
      
      
      
      
      
      

var AlsoViewedvue_type_style_index_0_lang_css_options = {};

AlsoViewedvue_type_style_index_0_lang_css_options.styleTagTransform = (styleTagTransform_default());
AlsoViewedvue_type_style_index_0_lang_css_options.setAttributes = (setAttributesWithoutAttributes_default());

      AlsoViewedvue_type_style_index_0_lang_css_options.insert = insertBySelector_default().bind(null, "head");
    
AlsoViewedvue_type_style_index_0_lang_css_options.domAPI = (styleDomAPI_default());
AlsoViewedvue_type_style_index_0_lang_css_options.insertStyleElement = (insertStyleElement_default());

var AlsoViewedvue_type_style_index_0_lang_css_update = injectStylesIntoStyleTag_default()(AlsoViewedvue_type_style_index_0_lang_css_/* default */.Z, AlsoViewedvue_type_style_index_0_lang_css_options);




       /* harmony default export */ var components_AlsoViewedvue_type_style_index_0_lang_css_ = (AlsoViewedvue_type_style_index_0_lang_css_/* default */.Z && AlsoViewedvue_type_style_index_0_lang_css_/* default.locals */.Z.locals ? AlsoViewedvue_type_style_index_0_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/components/AlsoViewed.vue?vue&type=style&index=0&lang=css&

;// CONCATENATED MODULE: ./src/scripts/vue/components/AlsoViewed.vue



;


/* normalize component */

var AlsoViewed_component = (0,componentNormalizer/* default */.Z)(
  components_AlsoViewedvue_type_script_lang_js_,
  AlsoViewedvue_type_template_id_ca2a808a_v_if_viewedProducts_length_20_3E_200_render,
  AlsoViewedvue_type_template_id_ca2a808a_v_if_viewedProducts_length_20_3E_200_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AlsoViewed = (AlsoViewed_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/templates/Product.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Productvue_type_script_lang_js_ = ({
  name: 'Product',
  components: {
    Gallery: Gallery,
    VImg: VImg/* default */.Z,
    ProductForm: ProductForm,
    Installments: Installments/* default */.Z,
    ProductPeripheralBoxes: ProductPeripheralBoxes,
    ProductPeripheralAccordion: ProductPeripheralAccordion,
    Recommended: Recommended,
    AlsoViewed: AlsoViewed
  },
  props: ['product', 'handle', 'selected_or_first_available_variant', 'has_default_variant', 'collection_handle'],

  data() {
    return {
      settings: null,
      metafields: null,
      activeVariant: {},
      label_conf: null,
      collection_images: null,
      socials_html: null,
      productId: null
    };
  },

  computed: {
    price() {
      return this.activeVariant.price ? this.activeVariant.price : this.product.price;
    },

    salePrice() {
      return this.activeVariant.compare_at_price ? this.activeVariant.compare_at_price : this.product.variants[0].compare_at_price;
    },

    label() {
      let label = null;

      for (const labelKey in this.label_conf) {
        if (this.product.tags.includes(`Label: ${labelKey}`)) {
          label = labelKey;
          break;
        }
      }

      if (!label) {
        label = this.product.tags.find(tag => tag.includes('Label:'));
      }

      return label ? label.replace('Label: ', '') : '';
    },

    labelStyle() {
      const conf = this.label_conf ? this.label_conf[this.label] : null;
      return conf ? `color: ${conf.color}; background: ${conf.background};` : 'color: var(--sage); background: var(--mint);';
    }

  },

  mounted() {
    this.loadSettings();
    this.loadMetafields();
    this.bootstrapOkendoComponents();

    if (this.has_default_variant) {
      this.activeVariant = this.selected_or_first_available_variant;
    }

    fetch('/collections/all?view=labels').then(res => res.json()).then(data => {
      this.label_conf = JSON.parse(data);
    });
    fetch('/collections/all?view=socials').then(res => res.text()).then(text => {
      this.socials_html = text;
    });
    if (this.collection_handle) fetch(`/collections/${this.collection_handle}?view=more-in`).then(res => res.json()).then(data => {
      this.collection_images = data;
      this.$preloadImages(this.collection_images, '500x');
      this.$preloadImages(this.collection_images, '1000x');
    });
  },

  methods: {
    loadSettings() {
      // Collection template at /collections/all?view=product
      fetch('/collections/all?view=product').then(res => res.json()).then(settings => {
        if (settings.length) {
          this.settings = JSON.parse(settings);
        }
      });
    },

    loadMetafields() {
      // Product template at /products/:handle?view=metafields
      fetch(`/products/${this.handle}?view=metafields`).then(res => res.json()).then(metafields => {
        this.metafields = metafields;
      });
    },

    updateVariant(variant) {
      this.activeVariant = variant;
    },

    // Set the product id and review url and refresh okendo
    bootstrapOkendoComponents() {
      this.productId = `shopify-${this.product.id}`;
      this.writeReviewUrl = `https://reviews.okendo.io/stores/b4c27e16-592e-4d18-ad52-9e6d27339ce0/review?productId=${this.productId}`;

      if (typeof window.refreshOkendo === 'function') {
        window.refreshOkendo();
      }
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/templates/Product.vue?vue&type=script&lang=js&
 /* harmony default export */ var templates_Productvue_type_script_lang_js_ = (Productvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/templates/Product.vue





/* normalize component */
;
var Product_component = (0,componentNormalizer/* default */.Z)(
  templates_Productvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Product = (Product_component.exports);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346,383,67], function() { return __webpack_exec__(9198); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);